<template>
  <div style="width: 1200px;margin: 0 auto;height: 100%" class="xh">
    <el-tabs :tab-position="tabPosition" v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane label="宣传教育" name="first">
        <div style="text-align: left;padding-left: 50px">
          <div v-for="(item, index) in publicityList.slice((this.queryInfo.currentPage-1)*this.queryInfo.pagesize,this.queryInfo.currentPage*this.queryInfo.pagesize)" :key="index" >
            <div class="content">
            <div class="pi">
              <router-link :to="{name:'Newsparticulars',query: { id: item.id}}">{{ item.title }}</router-link>
            </div>
            <div>
              <p >{{ item.update_time}}</p>
            </div>
          </div>

          </div>
           <!--分页区域-->
           <el-pagination
            style="text-align: center;padding-top: 30px;"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryInfo.currentPage"
            :page-sizes="[10,20,30]"
            :page-size="queryInfo.pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total
          ">
          </el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="培训平台" name="second">

        <div style="text-align: left;padding-left: 50px">
          <div v-for="(item, index) in educationList.slice((this.query.currentPage-1)*this.query.pagesize,this.query.currentPage*this.query.pagesize)" :key="index" >
            <div class="content">
            <div class="pi">
              <span @click="edu(item.href)">{{ item.title }}</span>
            </div>
            <div>
              <p >{{ item.update_time}}</p>
            </div>
          </div>

          </div>
          <!--分页区域-->
          <el-pagination
            style="text-align: center;padding-top: 30px;"
            @size-change="handleSizeChange2"
            @current-change="handleCurrentChange2"
            :current-page="query.currentPage"
            :page-sizes="[10,20,30]"
            :page-size="query.pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total2
          ">
          </el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Utils from '../../assets/js/util.js';
export default {
  name: "Publicityedu",
  data(){
    return{
      tabPosition: 'left',
      activeName: 'first',
      publicityList: [],
      educationList: [],
      queryInfo: {
        currentPage: 1,//当前页数
        pagesize: 10,//每页显示条目个数
      },
      query: {
        currentPage: 1,//当前页数
        pagesize: 10,//每页显示条目个数
      },
      total2:0,
      total:0
    }
  },
  mounted(){
    let that=this;
    Utils.$on('demo', function (msg) {
      if(msg == '6-1'){
        that.activeName = "first";
        that.handleClick(that.activeName)
      }else if(msg == '6-2'){
        that.activeName = "second";
        that.handleClick(that.activeName)
      }
    });
    let name = sessionStorage.getItem('currentTab')
    // 判断是否存在currentTab，即tab页之前是否被点击切换到别的页面
    if(name){
      this.activeName = name
    }
  },
  beforeRouteLeave(to, from, next){
    // 在离开此路由之后清除保存的状态（我的需求是只需要在当前tab页操作刷新保存状态，路由切换之后不需要保存）
    // 根据个人需求决定清除的时间
    sessionStorage.removeItem('currentTab')
    next()
  },
  created() {
    let a = this.$route.query.act;
    if(a=='first'){
      this.activeName = "first";
      this.handleClick(this.activeName)
    } else if(a=='second'){
      this.activeName = "second";
      this.handleClick(this.activeName)
    }


  },
  methods: {
    /*宣传教育*/
    publicity(){
      this.axios.post('/api/index/publicityList',this.queryInfo).then((response) => {
        console.log(response)
        this.publicityList=response.data.data.data
        this.total=response.data.data.total
        // if(response.data.msg == 'success'){
        //   for (var i=0;i<response.data.data.data.length;i++) {
        //     var time = response.data.data.data[i].create_time
        //     var timearr = time.replace(" ", ":").replace(/\:/g, "-").split("-");
        //     var yue = timearr[1];
        //     var ri = timearr[2];
        //     this.publicityList.push({
        //       id: response.data.data.data[i].id,
        //       title: response.data.data.data[i].title,
        //       content: response.data.data.data[i].content,
        //       month: yue,
        //       day: ri
        //     })
        //   }
        // }
      }).catch(function (error) {
        console.log(error);
      });
    },
    /*培训平台*/
    education(){

      this.axios.post('/api/index/educationList',this.query).then((response) => {
        console.log(response)
        this.educationList=response.data.data.data
        this.total2=response.data.data.total
        // if(response.data.msg == 'success'){
        //   for (var i=0;i<response.data.data.data.length;i++) {
        //     var time = response.data.data.data[i].create_time
        //     var timearr = time.replace(" ", ":").replace(/\:/g, "-").split("-");
        //     var yue = timearr[1];
        //     var ri = timearr[2];
        //     this.educationList.push({
        //       id: response.data.data.data[i].id,
        //       title: response.data.data.data[i].title,
        //       href: response.data.data.data[i].href,
        //       month: yue,
        //       day: ri
        //     })
        //   }
        // }
      }).catch(function (error) {
        console.log(error);
      });
    },
    handleClick(tab) {
      if(tab==='first'){
        this.publicity();
      }else if(tab==='second'){
        this.education();
      }
    },
    handleTabClick(tab) {
      if(tab.name==='first'){
        this.publicity();
      }else if(tab.name==='second'){
        this.education();
      }
      // 点击tab后触发事件，修改显示页面，将状态保存在sessionStorage里面
      sessionStorage.setItem('currentTab', tab.name)
    },
      //监听 pagesize 改变的事件
      handleSizeChange(newSize){
      this.queryInfo.pagesize = newSize
      this.publicity();
    },
    //监听 页码值 改变的事件
    handleCurrentChange(newPage){
      this.queryInfo.currentPage = newPage
      this.publicity();
    },
    //监听 pagesize 改变的事件
    handleSizeChange2(newSize){
      this.query.pagesize = newSize
      this.education()
    },
    //监听 页码值 改变的事件
    handleCurrentChange2(newPage){
      this.query.currentPage = newPage
      this.education()
    },

    edu(href){
      window.open(href)
    }
  }
}
</script>

<style scoped>
.xh >>>.el-tabs__nav-wrap::after {
  position: static !important;
}
.xh >>>.el-tabs__active-bar {
  background-color: transparent !important;
}
.im{
  width: 20%;
  float: left;
  width: 60px;
  height: 55px;
  text-align:center;
  background-color: #2F93b7;
  color: rgb(255, 255, 255);
}
.pi{
  /*float: left;*/
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 18px;
  text-align: left;

  cursor:pointer;
}
.content{
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px dashed #ccc;
}
a {
  text-decoration: none;
  color: black;
}
.router-link-active {
  text-decoration: none;
}
.pi a:hover {
  color: #2F93b7 !important;

}
</style>



// WEBPACK FOOTER //
// src/components/view/Publicityedu.vue